import dayjs from "dayjs";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useGetInvoicesQuery as getInvoicesQuery } from "../../../../api/plamo-api";
import { ActionTableState } from "../../action-table/action-table";

function CustomerInvoiceList({ customerId, subpage }) {
  const navigate = useNavigate();
  
  const columns = useMemo(() => [
    {
      title: "Id",
      dataIndex: "id",
      sorter: true,
      filter: true,
      type: 'int',
    },
    {
      title: "Datum",
      dataIndex: "date",
      render: v => dayjs(v).format('DD.MM.YYYY')
    },
    {
      title: "Ende",
      dataIndex: "end",
      render: v => dayjs(v).subtract(1, 'day').format('DD.MM.YYYY')
    },
    {
      title: "Betrag",
      dataIndex: "amountNet",
    },
  ], [])

  /*
  const assignmentLinkQueryString = useMemo(() => {
    const resultMap = {
      preselectedEmployeeId,
      preselectedCustomerId,
    }
    const result = Object.entries(resultMap).filter(([_1, value]) => value).map(([key, value]) => `${key}=${value}`).join('&');
    return result ? `?${result}` : ''
  }, [])
  */

  const applyPreselectedToFilter = useCallback(f => {
    const obj = JSON.parse(f);
    obj["customer.id"] = {
      c: "EQ",
      v: customerId
    }
    return JSON.stringify(obj);
  }, [customerId])

  return (
    <>
    <div>
    <ActionTableState
          isParentLoading={false}
          buttonRow={{
            buttons: [
              {
                text: 'Neu',
                buttonType: 'primary',
                //onClick: () => navigate(`/customer/${customerId}/settlement/invoice/new`)
                onClick: () => navigate(`/settlement/invoice`)
              },
            ]
          }}
          tableData={{
            defaultSortKey: 'id',
            defaultSortDirection: 'desc',
            columns,
            dataSource: {
              pageableQueryEndpoint: ({ f, ...rest }) => getInvoicesQuery({ f: applyPreselectedToFilter(f), ...rest }),
              queryResultMapping: (result) => result?.items
            },
            actions: [
              {
                caption: 'Details',
                onClick: (item) => navigate(`/customer/${customerId}/settlement/invoice/${item.id}`)
              },
            ]
          }}            
        />
    </div>
    </>
  )
}

export default CustomerInvoiceList;